import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectVision, visionListUpdateSelected } from "../../app/actions/visionActions";
import { registerPanelViewInterest } from "../../app/helpers/intentTrackingHelper";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import ReadMoreReadLessVision from "../generic-read-more/ReadMoreReadLessVision";
import L5ModalVision from "./L5ModalVision";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { useTranslation } from "react-i18next";
import SemanticSimilarityBadge from "./SemanticSimilarityBadge";
import { canShowIntegrationDashboardBridge } from "../../app/helpers/semanticSearchConfigHelper";

const L4CardVision = ({ data, setCountCompareTechInContainer, moduleSelected }) => {

  debugLogPages(':: L4CardVision');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);
  const showSelect = canShowIntegrationDashboardBridge(configuration, 'vision');

  const [popupInformationTechIsOpen, setPopupInformationTechIsOpen] = useState(false);
  const isChecked = data.isSelected;

  const closeModal = () => {
    setPopupInformationTechIsOpen(false);
  }

  const handleViewVision = (e) => {
    e.preventDefault();
    dispatch(selectVision(data));
    registerPanelViewInterest(dispatch, 'vision', data);
    navigate(`/end-user-search/view-vision`);
  };

  //console.log("L4CardVision, data", data)


  const handleToggle = () => {
    dispatch(visionListUpdateSelected(data.id));
  };

  return (
    <li className="cards__item">
      <div className="card"
      >
        {showSelect && (
          <div>
            <label>
              <input type="checkbox" checked={Boolean(isChecked)} onChange={handleToggle} />
              <div className="espacioComparar">
                {isChecked ? t('general.card-selected') : t('general.card-select')}
              </div>
            </label>
          </div>
        )}
        {/*<div className="card__image" onClick={handlePopupSwall}>
          <PreviewImageShow />
        </div>*/}
        <div className="card__content">
          <SemanticSimilarityBadge data={data} moduleKey="vision" />
          <div className="card__title">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.topic}
            </ReadMoreReadLess>
          </div>
          <br />
          <div className="card__text">
            <ReadMoreReadLessVision 
              className='read-more-less' 
              buttonClassName='btn-read-more-less' 
              expandLabel="leer más" 
              collapseLabel="leer menos" 
              limit={100}  // Empieza mostrando 100 caracteres
              expandedLimit={300}    // Cada clic en "leer más" muestra 50 caracteres adicionales
              noReadMore={false}
            >
              {data && data.vision}
            </ReadMoreReadLessVision>
          </div>

          <button className="btn btn--block button-color-view" onClick={handleViewVision}>
            {t("buttons.view")}
          </button>

        </div>
      </div>

      <L5ModalVision
        modalIsOpen={popupInformationTechIsOpen}
        closeModal={closeModal}
        data={data}
        moduleSelected={moduleSelected}
      />

    </li>
  );
};

export default L4CardVision;
